export default "__VITE_ASSET__ca5b7d11__"